// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-width[data-v-5d1112c4]{width:100%}.created-on-text[data-v-5d1112c4]{font-size:0.8em}\n", ""]);
// Exports
module.exports = exports;
